export default __webpack_public_path__ + "static/stairs-7f51bd9da08580779f94a6e8a93e59af.jpg";